import React, { type FunctionComponent } from 'react'
import ReactDiffViewer, { type DiffMethod } from 'react-diff-viewer'

export type ContentDifferProps = {
  oldContent: string
  newContent: string
  diffMethod?: 'diffChars' | 'diffLines' | 'diffWords'
  hideLineNumbers?: boolean
  leftTitle?: string
  rightTitle?: string
  showDiffOnly?: boolean
}

export const ContentDiffer: FunctionComponent<ContentDifferProps> = ({
  oldContent,
  newContent,
  diffMethod,
  hideLineNumbers = false,
  leftTitle,
  rightTitle,
  showDiffOnly = true,
}) => (
  <ReactDiffViewer
    oldValue={oldContent}
    newValue={newContent}
    compareMethod={diffMethod as DiffMethod}
    hideLineNumbers={hideLineNumbers}
    leftTitle={leftTitle}
    rightTitle={rightTitle}
    showDiffOnly={showDiffOnly}
  />
)
